/** Tipos de Contatos */
export interface PessoaContatoTipo {
    id: number;
    nome: string;
    primario: boolean
    sequenciaPrimario?: number
}

export const contatoTipoPrincipal: PessoaContatoTipo = {id: 1, nome: 'Principal', primario: true, sequenciaPrimario: 1};
export const contatoTipoCobranca: PessoaContatoTipo = {id: 2, nome: 'Cobranca', primario: true, sequenciaPrimario: 2};
export const contatoTipoEntrega: PessoaContatoTipo = {id: 3, nome: 'Entrega', primario: true, sequenciaPrimario: 3};
export const contatoTipoCompras: PessoaContatoTipo = {id: 4, nome: 'Compras', primario: false};
export const contatoTipoVendas: PessoaContatoTipo = {id: 5, nome: 'Vendas', primario: false};
export const contatoTipoFinanceiro: PessoaContatoTipo = {id: 6, nome: 'Financeiro', primario: false};
export const contatoTipoQualidade: PessoaContatoTipo = {id: 7, nome: 'Qualidade', primario: false};
export const contatoTipoProducao: PessoaContatoTipo = {id: 8, nome: 'Produção', primario: false};
export const contatoTipoDiretorGerenteArea: PessoaContatoTipo = {id: 9, nome: 'Diretor/Gerente de Área', primario: false};
export const contatoTipoProprietarioDono: PessoaContatoTipo = {id: 10, nome: 'Proprietário/Dono', primario: false};
export const contatoTipoMarketing: PessoaContatoTipo = {id: 11, nome: 'Marketing', primario: false};
export const contatoTipoOutro: PessoaContatoTipo = {id: 99, nome: 'Outro', primario: false};

export const contatoTipos: PessoaContatoTipo[] = [
    contatoTipoPrincipal,
    contatoTipoCobranca,
    contatoTipoEntrega,
    contatoTipoCompras,
    contatoTipoVendas,
    contatoTipoFinanceiro,
    contatoTipoQualidade,
    contatoTipoProducao,
    contatoTipoDiretorGerenteArea,
    contatoTipoProprietarioDono,
    contatoTipoMarketing,
    contatoTipoOutro
];

/** Outros tipos de contato, fora os contatos Principal, Cobrança e Entrega */
export const outrosContatosTipos: PessoaContatoTipo[] = [
    contatoTipoCompras,
    contatoTipoVendas,
    contatoTipoFinanceiro,
    contatoTipoQualidade,
    contatoTipoProducao,
    contatoTipoDiretorGerenteArea,
    contatoTipoProprietarioDono,
    contatoTipoMarketing,
    contatoTipoOutro
];


/** Verifica se o tipo do contato informado é Principal */
export function isContatoTipoPrincipal(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoPrincipal.id;
}

/** Verifica se o tipo do contato informado é Cobranca */
export function isContatoTipoCobranca(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoCobranca.id;
}

/** Verifica se o tipo do contato informado é Entrega */
export function isContatoTipoEntrega(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoEntrega.id;
}

/** Verifica se o tipo do contato informado é Compras */
export function isContatoTipoCompras(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoCompras.id;
}

/** Verifica se o tipo do contato informado é Vendas */
export function isContatoTipoVendas(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoVendas.id;
}

/** Verifica se o tipo do contato informado é Financeiro */
export function isContatoTipoFinanceiro(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoFinanceiro.id;
}

/** Verifica se o tipo do contato informado é Qualidade */
export function isContatoTipoQualidade(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoQualidade.id;
}

/** Verifica se o tipo do contato informado é Produção */
export function isContatoTipoProducao(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoProducao.id;
}

/** Verifica se o tipo do contato informado é Direitor/Gerente de Área */
export function isContatoTipoDiretorGerenteArea(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoDiretorGerenteArea.id;
}

/** Verifica se o tipo do contato informado é Proprietário/Dono */
export function isContatoTipoProprietarioDono(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoProprietarioDono.id;
}

/** Verifica se o tipo do contato informado é Marketing */
export function isContatoTipoMarketing(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoMarketing.id;
}

/** Verifica se o tipo do contato informado é Outro */
export function isContatoTipoOutro(tipo: number): boolean {
    if (!tipo) {
        return false;
    }
    return tipo === contatoTipoOutro.id;
}

/** Verifica se o tipo do contato informa é um contato primário (Principal, Cobrança ou Entrega) */
export function isContatoTipoPrimario(tipo: number): boolean {
    return isContatoTipoPrincipal(tipo) || isContatoTipoCobranca(tipo) || isContatoTipoEntrega(tipo);
}
